// Admin feature types. Re-exports of the generated backend DTOs (single source of truth) plus
// local shapes for endpoints added ahead of backend codegen refresh.
export type {
  AccountViewResponseDTO,
  AccountCreationRequestDTO,
  AccountSearchRequestDTO,
  PageResponseAccountViewResponseDTO,
  RoleResponseDTO,
} from '@/api/generated/model';

// Activity-log row — GET /admin/api/account/{adminId}/activity-log (AdminAccountController,
// AdminServiceImpl.getActivityLog). Path stub is in openapi.json; run `pnpm codegen` to generate hooks.
export const ACCOUNT_ACTION_TYPE_LABEL: Record<string, string> = {
  C: 'Create',
  U: 'Update',
  UI: 'Update info',
  D: 'Delete',
  L: 'Login',
};

export interface ActivityLogEntryDTO {
  id?: number;
  /** adminId of the admin who performed the action. */
  actor?: number;
  /** Email of the acting admin at the time of the action. */
  actorEmail?: string;
  /** Enum code from AccountActionType (@JsonValue): C/U/UI/D/L. */
  actionType?: string;
  actionDetail?: string;
  actionTime?: string;
  jsonLog?: string;
}

// Admin account status values — real backend enum is NEW/ACT/TER (AccountViewResponseDTOAccountStatus).
export const ADMIN_STATUS = {
  New: 'NEW',
  Active: 'ACT',
  Terminated: 'TER',
} as const;
export type AdminStatus = (typeof ADMIN_STATUS)[keyof typeof ADMIN_STATUS];

// Re-export generated mutation request DTOs (PATCH /update, PATCH /change-status are in openapi.json).
export type { AccountStatusRequestDTO, AccountUpdatingRequestDTO } from '@/api/generated/model';
